export * from './chargeApi.service';
import { ChargeApiService } from './chargeApi.service';
export * from './clientDataApi.service';
import { ClientDataApiService } from './clientDataApi.service';
export * from './contactUsApi.service';
import { ContactUsApiService } from './contactUsApi.service';
export * from './estimatesApi.service';
import { EstimatesApiService } from './estimatesApi.service';
export * from './financing-bridgeAPI.service';
import { FinancingAPIService } from './financing-bridgeAPI.service';
export * from './formsApi.service';
import { FormsApiService } from './formsApi.service';
export * from './homeApi.service';
import { HomeApiService } from './homeApi.service';
export * from './invoicesApi.service';
import { InvoicesApiService } from './invoicesApi.service';
export * from './jobsApi.service';
import { JobsApiService } from './jobsApi.service';
export * from './loansAPI.service';
import { LoansAPIService } from './loansAPI.service';
export * from './logApi.service';
import { LogApiService } from './logApi.service';
export * from './loginApi.service';
import { LoginApiService } from './loginApi.service';
export * from './marketingApi.service';
import { MarketingApiService } from './marketingApi.service';
export * from './membershipsApi.service';
import { MembershipsApiService } from './membershipsApi.service';
export * from './payByBankApi.service';
import { PayByBankApiService } from './payByBankApi.service';
export * from './paymentLinkApi.service';
import { PaymentLinkApiService } from './paymentLinkApi.service';
export * from './phoneCaptureApi.service';
import { PhoneCaptureApiService } from './phoneCaptureApi.service';
export * from './savedCreditCardsApi.service';
import { SavedCreditCardsApiService } from './savedCreditCardsApi.service';
export * from './schedulerApi.service';
import { SchedulerApiService } from './schedulerApi.service';
export * from './statementsApi.service';
import { StatementsApiService } from './statementsApi.service';
export * from './visitAssistantApi.service';
import { VisitAssistantApiService } from './visitAssistantApi.service';
export const APIs = [ChargeApiService, ClientDataApiService, ContactUsApiService, EstimatesApiService, FinancingAPIService, FormsApiService, HomeApiService, InvoicesApiService, JobsApiService, LoansAPIService, LogApiService, LoginApiService, MarketingApiService, MembershipsApiService, PayByBankApiService, PaymentLinkApiService, PhoneCaptureApiService, SavedCreditCardsApiService, SchedulerApiService, StatementsApiService, VisitAssistantApiService];
